import styled from "styled-components";

export const AboutUsComp = styled.div`
    display: flex;
    margin: 3% 25%;
    @media (max-width: 1400px) {
        margin: 3% 20%;
    }
    @media (max-width: 1200px) {
        margin: 3% 15%;
    }
    @media (max-width: 1000px) {
        margin: 3% 10%;
    }

`;

export const AboutUsContent = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
`;

export const TextContent = styled.div`
    color: var(--purple-bhbusmidia);
    text-align: center;
`;

export const TextTitle = styled.div`
    h1 {
        font-size: 36px;
        color: var(--purple-dark);
    }
    h2 {
        font-weight: normal;
        font-family: "Montserrat";
        font-size: 21px;
        color: var(--purple-dark);
    }
`;

export const TextBody = styled.div`
    font-size: 24px;
    p {
        margin-top: 3%;
    }
`;

export const VideoContent = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 5%;
`;

export const NavMenu = styled.div`
    display: flex;
    text-align: center;
    align-items: center;
    font-size: 16px;
    margin: 0% 2%;
    color: var(--purple);
    font-weight: bold;
`;

export const NavUl = styled.ul``;

export const NavList = styled.p`
    padding: 5px;
`;


export const SearchDiv = styled.div``;

export const DoubleInput = styled.div`
    display: flex;
    justify-content: center;
    @media (max-width: 900px) {
        flex-direction: column;
    }
`;